<template>
  <VSplitButton
    v-if="hasSplitButton === true"
    class="split-btn"
  >
    <VButton
      v-if="types.includes(TransportOrder.Type.Internal)"
      @click="showInternalTransportOrderDialog"
    >
      Создать заявку на внутреннее перемещение
    </VButton>

    <VButton
      v-if="types.includes(TransportOrder.Type.OrderPositionPickup)"
      @click="showOrderPositionPickupTransportOrderDialog"
    >
      Создать ЗТК на забор у поставщика
    </VButton>

    <VButton
      v-if="types.includes(TransportOrder.Type.Return)"
      @click="showReturnTransportOrderDialog"
    >
      Создать заявку на возврат товара
    </VButton>

    <VButton
      v-if="types.includes(TransportOrder.Type.Service)"
      @click="showServiceTransportOrderDialog"
    >
      Создать заявку на аренду транспорта
    </VButton>
  </VSplitButton>

  <VButton
    v-if="types.includes(TransportOrder.Type.Consolidated)"
    theme="primary"
    @click="showConsolidatedTransportOrderDialog"
  >
    Создать консолидированную ЗТК
  </VButton>
</template>

<style scoped>

/** текст showInternalTransportOrderDialog не вмещается в попап,
  поэтому нужно расширить
  */
.split-btn {
  .mds-btn {
    min-width: 285px;
  }
}
</style>

<script lang="ts">

import TransportOrder from '@/domains/TransportOrders/TransportOrder';
import TransportOrdersService from '@/domains/TransportOrders/TransportOrdersService';

/**
 * Типы ЗТК, допустимые в пропе types. Выводятся из TransportOrder.Type —
 * новый тип ЗТК попадает сюда сам, перечислять руками не нужно.
 */
export type TransportOrderCreateButtonType = typeof TransportOrder.Type[keyof typeof TransportOrder.Type];

/** Типы ЗТК, кнопки которых живут в сплите. Консолидированная — отдельная кнопка. */
const SPLIT_TYPES: TransportOrderCreateButtonType[] = [
  TransportOrder.Type.Internal,
  TransportOrder.Type.OrderPositionPickup,
  TransportOrder.Type.Return,
  TransportOrder.Type.Service,
];

export default defineComponent({
  name: 'TransportOrderCreateButtons',

  props: {
    /** Документы для предзаполнения позиций (опционально, передаются из реестра при выборе строк) */
    selectedDocuments: {
      type: Array,
      default: () => [],
    },

    /**
     * Типы ЗТК, которые можно создать на этом экране. Тип и кнопка создания
     * связаны один к одному, поэтому набор кнопок задаётся списком типов.
     * Значения — id из TransportOrder.types.
     */
    types: {
      type: Array as PropType<TransportOrderCreateButtonType[]>,
      default: () => [],
    },
  },

  emits: ['transportOrder:created'],

  setup() {
    return {
      TransportOrder,
      TransportOrdersService,
    };
  },

  computed: {
    /** Сплит рендерится, только если внутри него есть хоть одна кнопка. */
    hasSplitButton(): boolean {
      return this.types.some(type => SPLIT_TYPES.includes(type));
    },
  },

  methods: {
    async showOrderPositionPickupTransportOrderDialog() {
      await TransportOrdersService.showOrderPositionPickupTransportOrderDialog(this.selectedDocuments)
      this.$emit('transportOrder:created')
    },
    async showInternalTransportOrderDialog() {
      await TransportOrdersService.showInternalTransportOrderDialog()
      this.$emit('transportOrder:created')
    },
    async showReturnTransportOrderDialog() {
      await TransportOrdersService.showReturnTransportOrderDialog(this.selectedDocuments)
      this.$emit('transportOrder:created')
    },
    async showServiceTransportOrderDialog() {
      await TransportOrdersService.showServiceTransportOrderDialog()
      this.$emit('transportOrder:created')
    },
    async showConsolidatedTransportOrderDialog() {
      await TransportOrdersService.showConsolidatedTransportOrderDialog(this.selectedDocuments)
      this.$emit('transportOrder:created')
    }
  }
});
</script>